import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';

// ==== 关键：使用 import 导入真实路径（打包后不会丢失） ====
import bg1 from '../../assets/image/优势1.png';
import bg2 from '../../assets/image/优势二.png';
import bg3 from '../../assets/image/优势三.png';
import bg4 from '../../assets/image/优势四.png';

interface ServiceHomePart1Props {}

interface eInteriorData {
    exterior: string;
    bg: string;
}

const ServiceHomePart1: React.FC<ServiceHomePart1Props> = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [interiorList, setInteriorList] = useState<eInteriorData[]>([]);

    /** ===========================
     * 多语言 + 背景图（import方式）
     =========================== */
    const dataZh: eInteriorData[] = [
        { exterior: '国际一流服务能力', bg: bg1 },
        { exterior: '首发律师获客智能AI', bg: bg2 },
        { exterior: '多元化专业化律师团队', bg: bg3 },
        { exterior: '规模化发展的践行者', bg: bg4 }
    ];

    const dataEn: eInteriorData[] = [
        { exterior: 'World-Class Service Capability', bg: bg1 },
        { exterior: 'AI-Powered Lawyer Acquisition', bg: bg2 },
        { exterior: 'Diverse & Professional Lawyer Team', bg: bg3 },
        { exterior: 'Pioneer in Scaled Development', bg: bg4 }
    ];

    useEffect(() => {
        setInteriorList(languageCode === 'en' ? dataEn : dataZh);
    }, [languageCode]);

    return (
        <div className='service-home-part1'>
            {interiorList.map((item, index) => (
                <div
                    key={index}
                    className='service-part1-item'
                    style={{
                        backgroundImage: `url(${item.bg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '16px'
                    }}
                >
                    <div className='item-exterior'>{item.exterior}</div>
                </div>
            ))}
        </div>
    );
};

export default ServiceHomePart1;
